export default function HeroSection() {
  return (
    <section
      id="home"
      className="relative min-h-screen flex flex-col items-center justify-center overflow-hidden"
    >
      {/* Background image */}
      <div className="absolute inset-0 w-full h-full">
        <img
          src="https://public.readdy.ai/ai/img_res/4aa7bafdf617372493af876244d874a6.jpg"
          alt="Hero background"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-gray-950/70 via-gray-900/60 to-gray-950/80" />
      </div>

      {/* Content */}
      <div className="relative z-10 text-center px-6 w-full max-w-5xl mx-auto">
        <p
          className="text-teal-400 text-sm font-semibold uppercase tracking-[0.25em] mb-6 opacity-0 animate-[fadeInDown_0.8s_ease_0.2s_forwards]"
        >
          iOS Application Development
        </p>
        <h1
          className="text-white text-5xl md:text-7xl font-bold leading-tight mb-6 opacity-0 animate-[fadeInDown_0.8s_ease_0.4s_forwards]"
          style={{ fontFamily: "'Inter', sans-serif" }}
        >
          Elevating iOS Experience
          <br />
          <span className="text-teal-400">Through Innovation</span>
        </h1>
        <p
          className="text-white/75 text-lg md:text-xl max-w-2xl mx-auto leading-relaxed opacity-0 animate-[fadeInDown_0.8s_ease_0.6s_forwards]"
        >
          DELPAK D.O.O. is a team of experts crafting premium VPN and Cleaner
          solutions that enhance security and performance of mobile devices.
        </p>

        {/* Scroll indicator */}
        <div className="mt-16 flex flex-col items-center gap-2 opacity-0 animate-[fadeInDown_0.8s_ease_1s_forwards]">
          <span className="text-white/40 text-xs tracking-widest uppercase">Scroll to explore</span>
          <div className="w-px h-10 bg-gradient-to-b from-white/40 to-transparent" />
        </div>
      </div>
    </section>
  );
}
